<template>
    <div style="background-color: white">
        <br>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>ลำดับที่</th>
                    <th>เลขที่บัญชี</th>
                    <th>รายการ</th>
                    <th>ดูข้อมูล</th>
                    <th>ดูข้อมูล(รายเดือน)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in bankList">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.account_number}}</td>
                    <td>{{data.account_name}} {{data.name}}</td>
                    <td>
                        <button class="btn btn-info" @click="getStatement(data.id)">
                            <icon name="eye"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-info" @click="getStatementMonth(data.id)">
                            <icon name="eye"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getPage">
        </vue-pagination>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg"></loading>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import VuePagination from "../../Pagination";
    import Loading from "../../Utility/Loading";

    export default {
        name: "statement",
        components:{Loading, VuePagination},
        created(){
            this.$store.dispatch("Bank/setBank");
        },
        data(){
            return{
                msg : '',
                status_loading : ''
            }
        },
        computed:{
            ...mapState({
                bankList : state=>{
                    return state.Bank.bankTable;
                },
                dataPaginate : state=>{
                    return state.Bank.dataPaginate
                }
            })
        },
        methods:{
            showLoading(){
                this.$refs.loading.show();
            },
            hideLoading(){
                this.$refs.loading.hide();
            },
            getStatement(id){
                this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
                this.showLoading();
                this.$store.dispatch("Bank/getStatement",{
                    bank_id : id,
                    start_date : "",
                    end_date : ""
                }).then(()=>{
                    this.hideLoading();
                    this.$router.push("/account/statement-form");
                });
            },
            getStatementMonth(id){
                this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
                this.showLoading();
                this.$store.dispatch("Bank/getStatementMonth",{
                    bank_id : id,
                    start_date : "",
                    end_date : ""
                }).then(()=>{
                    this.hideLoading();
                    this.$router.push("/account/statement-month-form");
                });
            },
            getPage(){
                this.page = this.dataPaginate.current_page;
                this.$store.dispatch("Bank/setBank",this.page);
            }
        }
    }
</script>

<style scoped>

</style>
